import { useEffect, useState } from 'react';
import { shopApi } from '../../../utils/shopApi';

// The club's kit for sale, loaded once per visit to the app
let cached = null;

export function clearShopProductsCache() {
  cached = null;
}

// { products, error, loading, reload }: error is true when it couldn't load,
// and reload() asks again
export default function useShopProducts() {
  const [products, setProducts] = useState(cached);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (cached) return undefined;
    let live = true;
    setError(false);
    shopApi.getProducts()
      .then(res => { cached = res.data; if (live) setProducts(res.data); })
      .catch(() => { if (live) setError(true); });
    return () => { live = false; };
  }, [attempt]);
  return { products, error, loading: !products && !error, reload: () => setAttempt(a => a + 1) };
}
